export const ACTIONS = {
  APP_MESSAGE_SHOW: 'APP_MESSAGE_SHOW',
  APP_MESSAGE_RESET: 'APP_MESSAGE_RESET',
}
